module.exports = __webpack_public_path__ + "img/developers.3758faa9.png";